import vue from '@/main'

import axios from "../../axios"
import store from "../../store/store"

axios.interceptors.request.use(
  config => {
    if (store.state.showLoadingOverlay) {
      vue.$vs.loading({
        type: 'radius'
      });
    }

    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }

    return config
  },
  error => {
    Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    vue.$vs.loading.close();
    return response;
  },
  async error => {
    vue.$vs.loading.close();
    const { config, response } = error;
    const originalRequest = config;

    vue.$emit('api-response', response);

    const ignoreUnauthorizedRoutes = ['two-factor'];
    const isPending2FA = localStorage.getItem('twoFactor') === 'true' && !localStorage.getItem('accessToken');
    const isIgnoredRoute = ignoreUnauthorizedRoutes.includes(vue.$router.currentRoute.name) || isPending2FA;
    if (response && response.status === 401) {
      if (
        (response.data.status === 'Unauthorized' && !isIgnoredRoute)
        || (response.data.status === 'Authorization Token not found' && !isIgnoredRoute)
        || (response.data.status === 'Token is Expired' && !isIgnoredRoute)
        || (response.data.status === 'Token is Invalid' && !isIgnoredRoute)
      ) {
        localStorage.removeItem("accessToken")
        vue.$vs.loading.close()
        return vue.$router.push('/login')
      }

      for (const error of response.data.errors) {
        console.error(error.message)
        if (error.message === 'Token has expired') {
          const accessToken = await store.dispatch("auth/refreshAccessToken")
          originalRequest.headers.Authorization = 'Bearer ' + accessToken

          return Promise.resolve(axios(originalRequest))
        }

        if (
          (error.message === 'Unauthorized' && !isIgnoredRoute)
          || (error.message === 'Authorization Token not found' && !isIgnoredRoute)
        ) {
          localStorage.removeItem("accessToken")
          vue.$vs.loading.close()
          return vue.$router.push('/login')
        }
      }
    }

    return Promise.reject(error)
  });

export default axios;